import { render, staticRenderFns } from "./WrapperPage.vue?vue&type=template&id=211a33e7&scoped=true"
import script from "./WrapperPage.vue?vue&type=script&lang=js"
export * from "./WrapperPage.vue?vue&type=script&lang=js"
import style0 from "./WrapperPage.vue?vue&type=style&index=0&id=211a33e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211a33e7",
  null
  
)

export default component.exports